import React from 'react';
import PropTypes from 'prop-types';
import { withChatStatus, statuses } from '../index';
import CardWithIcon from '../../card-with-icon';

export const WebchatCardWithIcon = ({ status, config, ...rest }) => {
  let subText;

  if (status === statuses.BUSY) {
    subText = config[`statusDescription${statuses.ONLINE}`];
  } else if (status === statuses.BANK_HOLIDAY) {
    subText = config[`statusDescription${statuses.OFFLINE}`];
  } else {
    subText = config[`statusDescription${status}`];
  }

  subText = {
    raw: JSON.stringify({
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: subText,
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    }),
  };

  const ctaText =
    status === statuses.ONLINE || status === statuses.BUSY
      ? config[`cardCta${statuses.ONLINE}`]
      : config[`cardCta${statuses.OFFLINE}`];

  return <CardWithIcon {...rest} subText={subText} ctaText={ctaText} />;
};

WebchatCardWithIcon.propTypes = {
  status: PropTypes.oneOf(Object.values(statuses)),
  config: PropTypes.object,
};

WebchatCardWithIcon.displayName = 'WebchatCardWithIcon';

export default withChatStatus(WebchatCardWithIcon);
